import {
  dragDropPieces,
  dragDropPiecesBlackWhiteSide,
} from './assignments'
import { createChessboard } from '../../utils'

let lessonConfig = [
  {
    id: 0,
    previous: null,
    next: 2,
    video: {
      src: 'img/videos/lesson_2/1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 1
    }
  },
  {
    id: 1,
    previous: 0,
    next: 2,
    audio: { src: 'img/audio/lesson_2/1.mp3', start: true, controls: false },
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Drag the pieces <br/>to their correct <br/>starting square. <br/>If you get it right, <br/>the piece will <br/>stay there, <br/>if you get it wrong, <br/>the piece will float <br/>back to the side.`,
      timeout: 10500
    },
    chessboard: {
      board: dragDropPieces({
        showIndicators: { allSides: true },
        piecesArray: ['bK', 'bQ', 'bR', 'bB', 'bN', 'bP', 'wK', 'wQ', 'wR', 'wB', 'wN', 'wP'],
        validatePieces: { 'bK': ['e8'], 'bQ': ['d8'], 'bR': ['a8', 'h8'], 'bB': ['c8', 'f8'], 'bN': ['b8', 'g8'], 'bP': ['a7', 'b7', 'c7', 'd7', 'e7', 'f7', 'g7', 'h7'], 'wK': ['e1'], 'wQ': ['d1'], 'wR': ['a1', 'h1'], 'wB': ['c1', 'f1'], 'wN': ['b1', 'g1'], 'wP': ['a2', 'b2', 'c2', 'd2', 'e2', 'f2', 'g2', 'h2'] },
        pieceLimit: { bK: 1, bQ: 1, bB: 2, bN: 2, bR: 2, bP: 8, wK: 1, wQ: 1, wB: 2, wN: 2, wR: 2, wP: 8 },
        fen: 'rnbqkbnr/pppppppp/8/8/8/8/PPPPPPPP/RNBQKBNR',
        pieceTheme: 'simple_black_white',
        next: 2
      })
    }
  },
  {
    id: 2,
    previous: 0,
    next: 5,
    video: {
      src: 'img/videos/lesson_2/2.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 3,
    }
  },
  {
    id: 3,
    previous: 2,
    next: 5,
    directions: {
      data: `<b>DIRECTIONS:</b> <br/>Drag the icons <br/>and titles to the <br/>correct quadrant <br/>on the board.`,
      timeout: 0
    },
    chessboard: {
      board: dragDropPiecesBlackWhiteSide({
        showIndicators: { allSides: true },
        singleSpare: true,
        piecesArray: ['bK', 'bQ', 'wK', 'wQ'],
        validatePieces: {
          'bK': ['e8', 'f8', 'g8', 'h8', 'e7', 'f7', 'g7', 'h7', 'e6', 'f6', 'g6', 'h6', 'e5', 'f5', 'g5', 'h5'],
          'bQ': ['a8', 'b8', 'c8', 'd8', 'a7', 'b7', 'c7', 'd7', 'a6', 'b6', 'c6', 'd6', 'a5', 'b5', 'c5', 'd5'],
          'wK': ['e4', 'f4', 'g4', 'h4', 'e3', 'f3', 'g3', 'h3', 'e2', 'f2', 'g2', 'h2', 'e1', 'f1', 'g1', 'h1'],
          'wQ': ['a4', 'b4', 'c4', 'd4', 'a3', 'b3', 'c3', 'd3', 'a2', 'b2', 'c2', 'd2', 'a1', 'b1', 'c1', 'd1']
        },
        pieceLimit: { bK: 1, bQ: 1, wK: 1, wQ: 1 },
        fen: '3qk3/8/8/8/8/8/8/3QK3',
        pieceTheme: 'assignment_2_2',
        assignmentClass: 'assignment-2-2',
        next: 4
      })
    }
  },
  {
    id: 4,
    previous: 2,
    next: 6,
    video: {
      src: 'img/videos/lesson_2/3.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 6,
    }
  },
  {
    id: 5,
    previous: 2,
    next: 6,
    video: {
      src: 'img/videos/lesson_2/3.1.mp4',
      startTime: 0,
      autoStartNext: true,
      next: 6,
    }
  },
  {
    id: 6,
    previous: 5,
    next: 7,
    audio: { src: 'img/audio/qa_bgm.mp3', start: true, loop: true },
    qa: {
      id: 0,
      question: 'Which chess pieces are friendly consultants to the King and Queen and start on the <br/> f and c file?',
      answer: [
        'Pawns',
        'Knights',
        'Bishops',
        'Rooks'
      ],
      rightAnswer: 'Bishops',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 7,
    previous: 5,
    next: 8,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 1,
      question: 'Which chess pieces buck and gallop and start the game on the b and g files?',
      answer: [
        'Pawns',
        'Knights',
        'Bishops',
        'Rooks'
      ],
      rightAnswer: 'Knights',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 8,
    previous: 5,
    next: 9,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 2,
      question: 'Which chess pieces stand high above approaching armies on the a and h files?',
      answer: [
        'Pawns',
        'Knights',
        'Bishops',
        'Rooks'
      ],
      rightAnswer: 'Rooks',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 9,
    previous: 5,
    next: 10,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 3,
      question: 'Which chess pieces stand in front of the other pieces filling the 2nd and 7th rank?',
      answer: [
        'Pawns',
        'Knights',
        'Bishops',
        'Rooks'
      ],
      rightAnswer: 'Pawns',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 10,
    previous: 5,
    next: 11,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 4,
      question: 'To set-up the board, it helps to remember the Queen loves...',
      answer: [
        'Rubies',
        'Emeralds',
        'Diamonds',
        'Coal'
      ],
      rightAnswer: 'Diamonds',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 11,
    previous: 5,
    next: 12,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 5,
      question: 'To set-up the board, it helps to remember the King oversees...',
      answer: [
        'The castle',
        'The farmland',
        'The people',
        'Everything'
      ],
      rightAnswer: 'Everything',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  }, {
    id: 12,
    previous: 5,
    next: 13,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'Which is the white side of the board?',
      answer: [
        'Ranks 1-4',
        'Ranks 5-8',
        'Files a-d',
        'Files e-h'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Ranks 1-4',
      validateAnswer: { rightAnswer: 0, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 13,
    previous: 5,
    next: 14,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 7,
      question: 'Which is the Queen side of the board?',
      answer: [
        'Ranks 1-4',
        'Ranks 5-8',
        'Files a-d',
        'Files e-h'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Files a-d',
      validateAnswer: { rightAnswer: 2, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 14,
    previous: 5,
    next: 15,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 8,
      question: 'Which is the King side of the board?',
      answer: [
        'Ranks 1-4',
        'Ranks 5-8',
        'Files a-d',
        'Files e-h'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Files e-h',
      validateAnswer: { rightAnswer: 3, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 15,
    previous: 5,
    next: 16,
    audio: { src: 'img/audio/qa_bgm.mp3', startTime: null },
    qa: {
      id: 6,
      question: 'Which is the black side of the board?',
      answer: [
        'Ranks 1-4',
        'Ranks 5-8',
        'Files a-d',
        'Files e-h'
      ],
      chessboard: {
        board: createChessboard({
          showIndicators: true,
        }),
        hint: true
      },
      rightAnswer: 'Ranks 5-8',
      validateAnswer: { rightAnswer: 1, userAnswer: -1 },
      styleClass: 'md'
    }
  },
  {
    id: 16,
    previous: 5,
    next: null,
    audio: { src: null, stop: true },
    qa: {
      position: 'center',
      nextLesson: 'Lesson Three',
      result: true,
      styleClass: 'xl'
    }
  }
];

let assets = [
  '/img/background_1.png',
  '/img/background_2.png',
  '/img/background_3.png',
  '/img/chesspieces/assignment_2_2/bK.svg',
  '/img/chesspieces/assignment_2_2/bQ.svg',
  '/img/chesspieces/assignment_2_2/wK.svg',
  '/img/chesspieces/assignment_2_2/wQ.svg'
];

let config = {
  config: lessonConfig,
  assets: assets
};

export default config;


// WEBPACK FOOTER //
// ./src/lessons/lesson_2/index.js